/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_ApprovedInputs */

const en_editor_filter_approved = /** @type {(inputs: Editor_Filter_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approved`)
};

const fr_editor_filter_approved = /** @type {(inputs: Editor_Filter_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approuvé`)
};

const de_editor_filter_approved = /** @type {(inputs: Editor_Filter_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genehmigt`)
};

const it_editor_filter_approved = /** @type {(inputs: Editor_Filter_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approvato`)
};

const ru_editor_filter_approved = /** @type {(inputs: Editor_Filter_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одобрено`)
};

const es_editor_filter_approved = /** @type {(inputs: Editor_Filter_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobado`)
};

const zh_cn2_editor_filter_approved = /** @type {(inputs: Editor_Filter_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已批准`)
};

const ja_editor_filter_approved = /** @type {(inputs: Editor_Filter_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認済み`)
};

const hi_editor_filter_approved = /** @type {(inputs: Editor_Filter_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुमोदित`)
};

const pt_pt2_editor_filter_approved = /** @type {(inputs: Editor_Filter_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovado`)
};

/**
* | output |
* | --- |
* | "Approved" |
*
* @param {Editor_Filter_ApprovedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_approved = /** @type {((inputs?: Editor_Filter_ApprovedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_ApprovedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_filter_approved(inputs)
	if (locale === "de") return de_editor_filter_approved(inputs)
	if (locale === "it") return it_editor_filter_approved(inputs)
	if (locale === "ru") return ru_editor_filter_approved(inputs)
	if (locale === "es") return es_editor_filter_approved(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_filter_approved(inputs)
	if (locale === "ja") return ja_editor_filter_approved(inputs)
	if (locale === "hi") return hi_editor_filter_approved(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_filter_approved(inputs)
	return en_editor_filter_approved(inputs)
});